import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './plugins/request'

//引入element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n en
// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
import { message } from "@/plugins/resetMessage";
Vue.prototype.$message = message


// 电话小窗的吸附
// import tel from '@/views/components/tel'
//全局js函数
import common from '@/plugins/common'
//全局引用common
Vue.prototype.$utils = common

//全局引入VueClipboard 复制粘贴
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 引入echarts
let echarts = require('echarts')
Vue.prototype.$echart = echarts

//引入语言切换
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem('languageSet') || 'en',   //从localStorage里获取用户中英文选择，没有则默认中文
  messages: {
    'zh': require('./components/language/zh'),
    'traditional': require('./components/language/traditional'),
    'en': require('./components/language/en'),
    "korean": require('./components/language/korean'),
    "japanese": require('./components/language/japanese'),
  }
})

// Vue.component('tel', tel)




Vue.config.productionTip = false

let vue = new Vue({
  store,
  router,
  i18n,   //把 i18n 挂载到 vue 根实例上
  // beforeMount() {
  //   const newMeta = document.createElement('meta')
  //   newMeta.content = "upgrade-insecure-requests";
  //   let name = "http-equiv"
  //   newMeta[name] = "Content-Security-Policy"
  //   console.log("newMeta", newMeta)
  //   document.head.appendChild(newMeta)
  // },
  render: h => h(App),
}).$mount('#app')

export default vue
